"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
const DayMapContext = /*#__PURE__*/ createContext(null);
function DayMapProvider({ children, dayMap = {
    variant: 'day'
}, mode = 'single', isMobile = false }) {
    const context = useMemo(()=>({
            dayMap,
            mode,
            isMobile
        }), [
        dayMap,
        mode,
        isMobile
    ]);
    return /*#__PURE__*/ jsx(DayMapContext.Provider, {
        value: context,
        children: children
    });
}
export { DayMapContext, DayMapProvider };
